// import { ElLoading } from 'element-plus';
import { Loading } from 'element-ui';
let loadingRequestCount = 0;
// 初始化loading
let loadingInstance = null

// 编写一个显示loading的函数 并且记录请求次数 ++
export const showLoading = (text = 'Loading...', bg = 'rgba(0, 0, 0, 0.8)', target) => {
    if (loadingRequestCount === 0) {
        // element的服务方式 target 我这边取的是表格class
        // 类似整个表格loading和在表格配置v-loading一样的效果，这么做是全局实现了，不用每个页面单独去v-loading
        loadingInstance = Loading.service({ target, background: bg, text });
    }
    loadingRequestCount++
}

// 编写一个隐藏loading的函数，并且记录请求次数 --
export const hideLoading = () => {
    if (loadingRequestCount <= 0) return
    loadingRequestCount--
    if (loadingRequestCount === 0) {
        loadingInstance.close();
    }
}